import type { SizeChartProps } from '@vp/lat-react-component-library'
import type { Logger } from '@vp/ubik-logging'

import { REQUESTOR } from '../utils/constants'

const baseUrl = 'https://sizechart-unifier.large-assortment.vpsvc.com'

export const getSizeChart = async (tenant: string, locale: string, productKey: string, logger: Logger): Promise<SizeChartProps> => {
  const queryParams = new URLSearchParams({
    requestor: REQUESTOR,
  })
  const url = `${baseUrl}/v1/sizechart/${tenant}/${locale}/coreproductid/${productKey}?${queryParams.toString()}`

  try {
    const request = new Request(url)
    const response = await fetch(request)

    if (!response.ok) {
      throw new Error(`Request to ${url} failed with status: ${response.status}`)
    }

    const data = (await response.json()) as SizeChartProps
    return data
  } catch (error) {
    if ((error as Error).message.includes('404')) {
      logger.info(`Size chart not found for productKey ${productKey} in ${locale}.`)
    } else {
      logger.error('Unable to retrieve size chart', error as Error, { productKey, locale, url })
    }
    throw error
  }
}
